import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

/**
 * Service for handling fetching clare/stripe onboarding status
 */

@Injectable({
  providedIn: 'root',
})
export class ClareOnboardingService {
  private requestOptions = {
    withCredentials: true,
    headers: {
      Accept: 'application/json',
    },
  };

  constructor(private http: HttpClient) {}
  /**
   * Retrieves clare onboarding information.
   * @param organizationId The ID of the organization for which to retrieve onboarding information.
   * @returns An onboarding account object.
   */

  retrieveAccount(organizationId: number): Observable<any> {
    return this.http.get<any>(
      `${environment.clareOnboardingUrl}/onboarding/accounts/organization:${organizationId}`,
      this.requestOptions
    );
  }
}
